import { render, staticRenderFns } from "./PickupForm.vue?vue&type=template&id=d8feff8a"
import script from "./PickupForm.vue?vue&type=script&lang=ts"
export * from "./PickupForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports